import { useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-32 pb-24 px-6 bg-stone-50">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-light text-gray-900 mb-6 tracking-wide">
            About the Author
          </h1>
          <div className="w-24 h-1 bg-amber-700 mx-auto"></div>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="py-24 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          {/* Author Profile */}
          <div className="grid md:grid-cols-2 gap-16 items-center mb-24">
            <div className="w-full h-96 md:h-full">
              <img
                src="https://static.readdy.ai/image/29014cc4b7daa6d5c6988d1d2c1b8cc2/d3c83160f5010847b1e80526e13a85c2.jpeg"
                alt="Kent Zimmerman"
                className="w-full h-full object-cover object-top rounded-lg shadow-xl"
              />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-8 tracking-wide">
                Kent Zimmerman
              </h2>
              <div className="space-y-6 text-base text-gray-700 leading-relaxed">
                <p>
                  <strong>Kent Zimmerman</strong> is a poet and visual storyteller whose work blends 
                  language, imagery, and emotion into an immersive artistic experience. His poetry 
                  moves beyond the page—each line reflects a moment, a memory, or a vision transformed 
                  into art.
                </p>
                <p>
                  With a unique voice that is both intimate and expansive, Kent invites readers to 
                  navigate the landscapes of life, loss, resilience, and human connection. His poetry 
                  collections pair expressive writing with artwork, creating a multisensory journey 
                  for readers and listeners alike.
                </p>
                <p>
                  Kent continues to write, paint, and inspire as he builds a literary universe 
                  celebrating imagination, reflection, and the beauty of expression.
                </p>
              </div>
            </div>
          </div>

          {/* Artistic Philosophy Section */}
          <div className="bg-stone-50 rounded-lg p-12 md:p-16">
            <h3 className="text-3xl font-light text-gray-900 mb-8 text-center tracking-wide">
              Artistic Philosophy
            </h3>
            <div className="max-w-4xl mx-auto space-y-6 text-base text-gray-700 leading-relaxed">
              <p className="text-center italic text-lg text-gray-800">
                "Poetry is not just words on a page—it's a living, breathing experience that engages 
                all the senses."
              </p>
              <p>
                Kent's approach to poetry is deeply rooted in the belief that art should be felt, not 
                just read. Each collection is carefully crafted to create an emotional resonance that 
                lingers long after the final page is turned.
              </p>
              <p>
                By integrating visual art with written verse, Kent creates a unique reading experience 
                where imagery and language work in harmony. His audiobooks take this concept further, 
                adding the dimension of voice and sound to bring each poem to life in new and unexpected 
                ways.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="py-24 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-6 tracking-wide">
            Explore the Collections
          </h2>
          <p className="text-base md:text-lg text-gray-600 mb-12 leading-relaxed">
            Discover Kent's poetry books, view the artwork that brings them to life, and experience 
            the audiobooks that add another dimension to the journey.
          </p>
          <div className="flex flex-wrap justify-center gap-6">
            <a
              href="/books"
              className="inline-block px-10 py-4 bg-amber-700 text-white text-sm font-light tracking-widest uppercase hover:bg-amber-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              View Books
            </a>
            <a
              href="/artwork"
              className="inline-block px-10 py-4 border border-gray-900 text-gray-900 text-sm font-light tracking-widest uppercase hover:bg-gray-900 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              View Artwork
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}